import {getCurrentYear} from '../../utils/commons'
import BestPersonalCarePicksLogo from './logo'
import {bestPersonalCarePicksStylesUK, bestPersonalCarePicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestpersonalcarepicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Personal Care Picks',
  favicon: '/favicons/bestpersonalcarepicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-SGHNNFDFC2',
    camelCaseUrl: 'BestPersonalCarePicks.com',
    logo: <BestPersonalCarePicksLogo locale="us" />,
    title: (category: string, count: string) =>
      `Top  ${count} ${category} ${getCurrentYear()} in the US | BestPersonalCarePicks.com – Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `Find top self-care and grooming products with expert reviews. Get the best skincare, haircare, and wellness essentials for your routine.`,
    styles: bestPersonalCarePicksStylesUS,
  },
  uk: {
    measurementId: 'G-8MYV8K32BH',
    camelCaseUrl: 'BestPersonalCarePicks.co.uk',
    logo: <BestPersonalCarePicksLogo locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the UK | BestPersonalCarePicks.co.uk – Reviews & Buying Guides`,
    description: (_category?: string, _count?: string) =>
      `Find top self-care and grooming products with expert reviews. Get the best skincare, haircare, and wellness essentials for your routine.`,
    styles: bestPersonalCarePicksStylesUK,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
